import * as logClient from "@classdojo/log-client";
import React from "react";
import CountdownControls from "./CountdownControls";
import CountdownTime from "./CountdownTime";
import ToolkitCard from "components/ToolkitCard";

const alarm = "/static/media/timer-complete.mp3";

type CountdownCardProps = {
  seconds: number;
  goBack: VoidFunction;
};

type CountdownCardState = {
  startTime: number;
  stoppedTime: number | null;
  seconds: number;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class CountdownCard extends React.Component<CountdownCardProps, CountdownCardState> {
  constructor(props: CountdownCardProps) {
    super(props);
    this.state = {
      startTime: Date.now(),
      stoppedTime: null,
      seconds: props.seconds,
    };
  }

  componentDidMount() {
    this.timer = window.setInterval(this.updateTime, 100);
  }

  componentWillUnmount() {
    this.stopInterval();
  }

  render() {
    const seconds = this.secondsRemaining();

    let toggle = this.state.stoppedTime ? this.resumeTimer : this.pauseTimer;
    let icon = this.state.stoppedTime ? "play" : "pause";
    if (seconds <= 0) {
      toggle = () => this.resetTimer(this.state.seconds);
      icon = "play";
      this.stopInterval();
    }

    return (
      <ToolkitCard close={this.closeTimer}>
        <CountdownTime seconds={seconds} />
        <audio src={alarm} ref={(node) => (this.audioNode = node)} />
        <CountdownControls
          seconds={seconds}
          icon={icon}
          toggle={toggle}
          restart={this.restartCurrentTimer}
          incrementTimer={this.incrementTimer}
        />
      </ToolkitCard>
    );
  }

  timer: number | undefined = undefined;
  audioNode: HTMLAudioElement | null = null;

  secondsRemaining = () => {
    const { seconds, startTime, stoppedTime } = this.state || { seconds: 0 };
    return Math.max(Math.ceil(seconds - ((stoppedTime || Date.now()) - startTime) / 1000), 0);
  };

  restartTimer = (input: number) => {
    this.setState({
      seconds: input,
      startTime: Date.now(),
      stoppedTime: null,
    });
    this.timer = window.setInterval(this.updateTime, 100);
  };

  updateTime = () => {
    this.forceUpdate();

    if (this.secondsRemaining() <= 0) {
      if (this.audioNode) {
        this.audioNode.play().catch(() => {
          logClient.sendMetrics([
            {
              type: "increment",
              value: 1,
              metricName: "toolkit.media.audio.play.error",
            },
          ]);
        });
      }
      this.setState({ stoppedTime: null });
    }
  };

  closeTimer = () => {
    this.props.goBack();
  };

  incrementTimer = () => {
    this.setState((state) => ({ ...state, startTime: state.startTime + 10 * 1000 }));
  };

  pauseTimer = () => {
    this.setState({ stoppedTime: Date.now() });
  };

  resumeTimer = () => {
    const { stoppedTime, startTime } = this.state;
    this.setState({
      startTime: Date.now() - ((stoppedTime ?? 0) - startTime),
      stoppedTime: null,
    });
  };

  resetTimer = (seconds: number) => {
    this.stopInterval();
    this.restartTimer(seconds);
  };

  restartCurrentTimer = () => {
    this.resetTimer(this.state.seconds);
  };

  stopInterval = () => {
    window.clearInterval(this.timer);
    this.timer = undefined;
  };
}
